import axios from "axios";
import { iStaffBaseURL } from "../constants/Urls";
import { convertISOToLocalDateObj } from "../functions/function";

const clientPlacementsReducer = (state = {}, payload) => {
  switch (payload.type) {
    case "FETCH_PLACEMENTS":
      return {
        ...state,
        completePlacements: payload.completePlacements,
        incompletePlacements: payload.incompletePlacements,
        pendingPlacements: payload.pendingPlacements,
        isLoading: false,
      };
    case "FETCH_EMPLOYEES":
      return {
        ...state,
        employees: payload.employees,
      };
    case "FETCH_CLIENTS":
      return {
        ...state,
        clients: payload.clients,
      };
    case "CREATE_PLACEMENT":
      return {
        ...state,
        incompletePlacements: payload.newPlacement
          ? [...state.incompletePlacements, payload.newPlacement]
          : state.incompletePlacements,
      };
    case "UPDATE_INCOMPLETE_PLACEMENTS":
      return {
        ...state,
        incompletePlacements: payload.incompletePlacements,
      };
    case "UPDATE_COMPLETE_PLACEMENTS":
      return {
        ...state,
        completePlacements: payload.completePlacements,
      };
    case "UPDATE_CLIENTS":
      return {
        ...state,
        clients: payload.updateClients,
      };
    case "START_LOADING":
      return {
        ...state,
        isLoading: true,
      };
    case "STOP_LOADING":
      return {
        ...state,
        isLoading: false,
      };

    case "UPDATE_PLACEMENT_TIME":
      return {
        ...state,
        pendingPlacemenst: payload.updatePlacementTime,
      };

    case "SUBMIT_MANUAL_TIMESHEET":
      return {
        ...state,
        pendingPlacements: payload.submitManualPlacement,
      };

    case "UPDATE_PENDING_PLACEMENTS":
      return {
        ...state,
        pendingPlacements: payload.updatePendingPlacements,
      };

    default:
      return state;
  }
};

/* Defines an incomplete placement */
function filterIncompletePlacements(placements) {
  if (!placements) {
    return [];
  }
  return placements.filter((p) => {
    /* If date in the future. It is incomplete */
    return new Date() < convertISOToLocalDateObj(p.end_time);
  });
}

/* Defines a complete placement. I.e. history. */
function filterCompletePlacements(placements) {
  if (!placements) {
    return [];
  }
  return placements.filter((p) => {
    if (p.timesheet) {
      if (
        p.timesheet.client_approval_status === "Approved" ||
        p.timesheet.client_approval_status === "Declined"
      ) {
        return true;
      }
    }
    return false;
  });
}

/* Defines a Pending placement. I.e. history. */
function filterPendingPlacements(placements) {
  if (!placements) {
    return [];
  }
  return placements.filter((p) => {
    if (p.timesheet) {
      if (p.timesheet.client_approval_status === "Pending") {
        /* If date in the past. */

        return new Date() > convertISOToLocalDateObj(p.end_time);
      } else {
        return false;
      }
    } else {
      return new Date() > convertISOToLocalDateObj(p.end_time);
    }
  });
}

export async function fetchClientPlacements(dispatch, getState) {
  const userToken = getState().userTokenReducer.userToken;
  dispatch({ type: "START_LOADING" });

  const requestHeader = {
    headers: {
      Authorization: "Token " + userToken,
    },
    timeout: 5000,
  };

  await axios
    .get(iStaffBaseURL + "/client/placements/", requestHeader)
    .then((response) => {
      dispatch({
        type: "FETCH_PLACEMENTS",
        completePlacements: filterCompletePlacements(response.data),
        incompletePlacements: filterIncompletePlacements(response.data),
        pendingPlacements: filterPendingPlacements(response.data),
      });
    })
    .catch((error) => {
      console.log(error);
      console.log("There was an error in the fetchClientPlacements reducer");
    });

  dispatch({ type: "STOP_LOADING" });
}
export default clientPlacementsReducer;
